<template>
  <div id="auditTop" class="main-page-content">
    <PageHeaderLayout :isBack="true">
      <div style="background: #fff; padding: 20px 20px">
        <el-form
          :inline="true"
          :model="searchCondition"
          class="demo-form-inline"
        >
          <el-form-item label="任务名称">
            <el-input
              clearable
              v-model="searchCondition.recruit_post"
              placeholder="请输入任务名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              clearable
              v-model="searchCondition.examine_status"
              placeholder="审核状态"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <DatePicker @dataSearch="dataSearch" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
          </el-form-item>
        </el-form>
        <div style="marrgin: 0 20px">
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#fbfbfb' }"
          >
            <el-table-column
              prop="recruit_post"
              label="任务名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="fullName"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sex"
              label="性别"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="age"
              label="年龄"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              align="center"
            ></el-table-column>

            <el-table-column prop="examine_status" label="状态" align="center">
              <template slot-scope="scope">
                {{ options_text[scope.row.examine_status] }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.examine_status == '0'"
                  size="mini"
                  type="primary"
                  @click="examineClick(scope.row)"
                  >审核</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-dialog
        v-if="examinedialogVisible"
        title=""
        :visible.sync="examinedialogVisible"
        width="50%"
        @close="closedialogVisible"
      >
        <el-radio-group v-model="radio">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="2">审核拒绝</el-radio>
        </el-radio-group>
        <div v-if="radio == 1" style="margin-top: 30px">
          <el-form
            :model="exameInfo"
            label-width="90px"
            :rules="userRules"
            ref="refExameInfo"
          >
            <el-form-item
              v-for="(item, index) in formList"
              :key="index"
              :label="item.label"
              :prop="item.props"
              :required="item.required"
              :rules="[
                {
                  required: item.required,
                  message: '请输入' + item.label,
                  trigger: 'blur',
                },
              ]"
            >
              <template v-if="item.type == 'input'">
                <el-input
                  v-model="exameInfo[item.props]"
                  :placeholder="item.placeholder"
                ></el-input>
              </template>
              <template v-else-if="item.type == 'picker'">
                <el-select
                  v-model="exameInfo[item.props]"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item1, index1) in item.selectOption"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closedialogVisible">取 消</el-button>
          <el-button type="primary" @click="saveConfirm">确 定</el-button>
        </span>
      </el-dialog>

      <el-pagination
        style="float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagege.current_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagege.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagege.total"
      ></el-pagination>
    </PageHeaderLayout>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import {SALARY_TYPE_LIST} from "@/utils/utils.js"
export default {
  components: {
    DatePicker,
    PageHeaderLayout,
  },
  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入失败原因!"));
      } else {
        callback();
      }
    };
    return {
      query: {},
      shenheData: [],
      exameInfo: {},
      formList: [
        {
          required: true,
          label: "结算工资",
          type: "input",
          props: "salary_money",
          placeholder: "请输入结算工资",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",
          value: "",
          disabled: false,
          show: true,
        },
      ],
      options_text: ["待审核", "审核通过", "审核拒绝"],
      options: [
        {
          value: "0",
          label: "待审核",
        },
        {
          value: "1",
          label: "审核通过",
        },
        {
          value: "2",
          label: "审核拒绝",
        },
      ],
      searchCondition: {},
      pagege: {},
      currentPage2: "",
      id: "",
      Status: "",
      mission_content: "",

      userList: {
        textarea: "",
      },
      radio: 1,
      examinedialogVisible: false,
      tableData: [],
      ispage: 1,
      num: 10,
      userRules: {
        textarea: [{ required: true, validator: checkName, trigger: "blur" }],
      },
    };
  },
  created() {
    this.query = this.$route.query;
    this.init();
  },

  methods: {
    closedialogVisible(){
      this.examinedialogVisible = false;
      this.exameInfo = {};
      this.radio = 1;
    },
    // 搜索
    searchButton() {
      this.init();
    },
    //获取选中日期的值
    dataSearch(value) {
      console.log(value);
      this.searchCondition.time = {};
      this.searchCondition.time.start_time = value[0];
      this.searchCondition.time.end_time = value[1];
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.num = val;
      this.ispage = 1;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.ispage = val;
      this.init();
    },
    async init() {
      let objects = {
        current_page: this.ispage,
        page_size: this.num,
        recruit_post: this.searchCondition.recruit_post,
        time: this.searchCondition.time,
        recruit_task_id: this.query.id,
      };
      let res = {};
      res = await this.$api.getDaily_taskJoin_list(objects);
      let { data, pages } = res;
      console.log(pages);
      this.tableData = data;
      this.pagege = pages;
    },

    userClose() {},
    examineClick(row) {
      this.id = row.join_id;
      this.radio = 1;
      this.userList.textarea = "";
      this.examinedialogVisible = true;
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      if(this.radio == 1){
        this.$refs["refExameInfo"].validate((valid) => {
        if (valid) {
          this.userInfo();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      }else{
        this.userInfo();
      }
      
      return true;
    },
    async userInfo() {
      let obj = {
        id: this.id,
        examine_status: this.radio,
      };
      if(this.radio == 1){
        obj = {
          ...obj,
          ...this.exameInfo,
        }
      }
      console.log(obj, "obj");

      await this.$api.postDaily_deliver_signup_audit(obj);
      this.$nextTick(() => {
          this.$message.success("审核成功!");
          this.init();
          this.closedialogVisible()
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-page-content {
  padding-bottom: 50px;
}
</style>
